module.exports = __webpack_public_path__ + "media/site/images/icons/livedata-icon-61b468f827f8b1de2a3b8cb37ae870b5.svg";